import script from "./Top.vue?vue&type=script&setup=true&lang=js"
export * from "./Top.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&lang=scss"
import "./Top.vue?vue&type=style&index=1&id=ad28c0b4&lang=scss&scoped=true"

import exportComponent from "/Users/kobayashiyasutaka/Documents/Projects/murakihp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad28c0b4"]])

export default __exports__